import React from 'react'
import { useNavigate } from "react-router-dom"

import IconFrame from '../../components/IconFrame'

export default({data, compact = false}) => {
  const navigate = useNavigate()
  let titleStyle = ""
  
  // if (theme === "dark") titleStyle = "text-white"

  const onCardClick = (d) => {
    console.log("::::", d)
    if (!d.url) {
      const url = `/${d.clinic ? `${d.clinic}/` : ''}services/${d.slug}`
      navigate(url)
    } else {
      window.open(d.url)
    }
  }

  return (
    <div className={`gap-2 md:gap-4 service-card ${ compact ? 'text-center md:text-left' : 'text-left' } px-8 py-4`} onClick={() => onCardClick(data)}>
      {
        data.icon !== "" &&
        <div className="block mx-auto">
          <IconFrame icon={data.icon} size="medium" />
        </div>
      }
      <h1 className={`md:block service-card-title ${ compact ? 'text-md' : 'text-lg'} font-bold lowercase text-sky-500 ${titleStyle}`}>
        {data.title}
      </h1>
      {
        !compact && data.shortDescription && 
        <div className="ecs-text max-w-xs text-sm" dangerouslySetInnerHTML={{__html: data.shortDescription}}></div>
      }
    </div>
  )
}